<template>
  <div>
    <v-bottom-navigation
      fixed
      app
      grow
      light
      height="72"
      style="background-image: url(/assets/app/visionx/phone_screen_bottom.png);   background-repeat: no-repeat; background-position: top center; background-size: 100% auto;"
    >
      <!-- New Team Button -->
      <v-btn
        v-if="show_new_team"
        @click="create_clinic_dialog = true"
      >
        <span>New</span>
        <v-icon>fa fa-plus</v-icon>
      </v-btn>

      <!-- Admin Menu -->
      <v-btn v-if="current_user.is_admin" :to="'/app/admin/clinics'">
        <span>{{ $t("main_menu.admin") }}</span>
        <v-icon>fa fa-cogs</v-icon>
      </v-btn>

      <!-- Single Clinic Link -->
      <v-btn
        v-if="clinics.length === 1"
        :to="'/app/clinic/' + clinics[0].id"
      >
        <span>
          TRAIN
        </span>
        <v-icon>fa-solid fa-clipboard-list</v-icon>
      </v-btn>

      <!-- Multiple Clinics Menu -->
      <v-menu v-if="clinics.length > 1" top offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on">
            TRAIN
            <v-icon>fa-solid fa-clipboard-list</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="clinic in clinics"
            :key="clinic.id"
            :to="'/app/clinic/' + clinic.id"
            link
          >
            <v-list-item-title>{{ clinic.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>


      <!-- Shared Grids Buttons -->
      <v-btn
        v-for="(shared_grid, sg_i) in shared_grids"
        :key="'shared-' + sg_i"
        :to="'/app/grid_set/' + shared_grid.id"
      >
        <span>{{ shared_grid.title }}</span>
        <v-icon color="#ec2027">mdi-run-fast</v-icon>
      </v-btn>

      <!-- Progress Report -->
      <v-btn v-if="user_regimen" to="/app/progress_report">
        <span>REPORT</span>
        <v-icon>fa-chart-bar</v-icon>
      </v-btn>



      <!-- Account/ Calibration etc. -->
      <!-- 
      <v-btn
        v-if="current_user"
        @click="settings_dialog = true"
      >
        <span>SETTINGS</span>
        <v-icon>mdi-settings</v-icon>
      </v-btn>
      -->
    </v-bottom-navigation>

    <!-- Phone settings dialog -->
    <v-dialog v-model="settings_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <PhoneSettings
        @close="settings_dialog = false"
      />
    </v-dialog>
  </div>

</template>

<script>
import { mapState } from "vuex";
import { firstAssignedGridSchedule } from "../../shared/lib/regimen_grid";

import ClinicEdit from "../../shared/components/ClinicEdit.vue";
import PhoneSettings from "./PhoneSettings.vue";

export default {
  components: { ClinicEdit, PhoneSettings },
  props: {
    user: {
      type: Object,
      required: true,
    },
    clinics: {
      type: Array,
      default: () => [],
    },
    collapsed: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    let data = {
      dark_mode_toggle: this.$root.$children[0].$vuetify.theme.dark,
      create_clinic_dialog: false,
      shared_grids: [],
      settings_dialog: false,
      default_clinic: {
        title: "",
        phone: "",
        website: "",
        physical_address_1: "",
        physical_address_2: "",
        physical_sub_locality: "",
        physical_locality: "",
        physical_sub_district: "",
        physical_district: "",
        physical_postal: "",
        physical_country: "XX",
        billing_address_1: "",
        billing_address_2: "",
        billing_sub_locality: "",
        billing_locality: "",
        billing_sub_district: "",
        billing_district: "",
        billing_postal: "",
        billing_country: "US",
        trial_end: null,
        tags: [],
        app: window.app_config.id,
        billing_strategy: window.app_config.default_billing_strategy,
      },
    };

    return data;
  },
  computed: {
    ...mapState([
      "current_user",
      "user_regimens",
      "current_clinic_id",
      "user_metadata",
      "current_invite",
      "highest_perm",
      "user_clinics",
      "grid_sets",
    ]),
    view_store() {
      for (var i in this.clinics) {
        if (
          this.clinics[i].user_role == "admin" ||
          this.clinics[i].user_role == "staff"
        )
          return true;
      }
      if (this.user.is_admin) {
        return true;
      }
      return false;
    },
    view_exercises() {
      if (this.user.is_admin) {
        return true;
      }
      return false;
    },
    user_regimen() {
      for (let user_regimen of this.user_regimens) {
        if (user_regimen.clinic_id == this.current_clinic_id) {
          return user_regimen;
        }
      }
      return null;
    },
    show_history() {
      if (this.user_metadata) {
        for (let metadata of this.user_metadata) {
          if (metadata.category == "completed_grid_schedule") {
            return true;
          }
        }
      }
      const assignment = firstAssignedGridSchedule(this.user_regimen);
      if (
        !assignment ||
        !assignment.grid_schedule ||
        !assignment.grid_schedule.grid.length
      ) {
        return false;
      }
      return (
        assignment.grid_current_stage !=
        assignment.grid_schedule.grid[0].id
      );
    },
    show_new_team() {
      for (let metadata in this.user_metadata) {
        if (metadata.category == "partner" && metadata.data === true) {
          return false;
        }
      }
      return false;
    },
  },
  mounted() {
    let shared_grid_ids = [];

    for (let clinic of this.user_clinics) {
      if (clinic.has_tag("shared_grid_set")) {
        let allowed_roles = ["staff", "admin"];
        if (clinic.has_tag("shared_grid_set_roles")) {
          allowed_roles = clinic.tag_value("shared_grid_set_roles");
        }
        if (allowed_roles.includes(clinic.user_role)) {
          let val = clinic.tag_value("shared_grid_set");
          if (typeof val == "string") {
            shared_grid_ids.push(val);
          } else {
            shared_grid_ids.push(...val);
          }
        }
      }
    }

    if (shared_grid_ids.length) {
      this.$store.dispatch("loadGrids", () => {
        for (let grid of this.grid_sets) {
          if (shared_grid_ids.includes(grid.id)) {
            this.shared_grids.push(grid);
          }
        }
      });
    }
  },
  methods: {
    go_to_clinic(clinic_id) {
      // TODO: Not working
      this.$store.commit("setCurrentClinicId", clinic_id);
      this.$router.push("/app/clinic/" + clinic_id);
    },
    toggle_dark_mode() {
      if (this.dark_mode_toggle) {
        this.dark_mode_toggle = false;
      } else {
        this.dark_mode_toggle = true;
      }
      this.dark_mode();
    },
    dark_mode() {
      messageBus.$emit("dark-mode", this.dark_mode_toggle);
    },
    load_clinics() {
      this.$store.dispatch("loadCurrentUser");
    },
  },
};
</script>
